<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11rro6B/images/9780316215664.jpg?1733067579398" alt="This image is the cover for the book Me and the Devil"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Me and the Devil
      </h1>
      <p class="bookDescription body article font2">
        <p>An aging New Yorker, a writer named Nick, feels life ebbing out of him. The world has gone to hell and Nick is so sick of it all that he can't even have a glass of champagne. Then one night he meets a tantalizing young woman who agrees to come back to his apartment. Their encounter is the most strangely extraordinary of his life. Propelled by uncontrollable, primordial desires, he enters a new and unimagined dimension of the forbidden and is filled with a sexual and spiritual ecstasy that is as intense as it is unholy. <br/><br/> Suddenly Nick's senses are alive. He feels strong, unconquerable, beyond all inhibition and earthly morality. He indulges in life's pleasures, pure and perverse, sublime and dangerous, from the delicate flavors of the perfect tomato to the fleshy beauty of a woman's thigh. But Nick's desire to sustain his rapture leads him to a madness and a darkness far greater and dreadful than have ever ridden the demon mares of night. Writing in a lineage that includes Dante, William S. Burroughs, Charles Bukowski, Hubert Selby, Jr., and Hunter S. Thompson, Nick Tosches may be America's last real literary outlaw -- a fearless, uncensorable seeker of our deepest secret truths and desires, from the basest to the most beautiful. <br/><br/><i>Me and the Devil</i> is outrageous, disturbing, and brilliant, a raw and blazing novel truly unlike any other. Like the man said: Read him at your peril. <br/><br/><b>"A raw and blazing novel by "the single, most brain-searingly dangerous man of letters. Read him at your peril." --  Anthony Bourdain</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nick Tosches
      </h2>
      
      <p class="authorDescription body article"><B>Nick Tosches</B>&#160;(1949-2019) was the author of four previous novels,&#160;<I>Me and the Devil</I>,&#160;<I>In the Hands of Dante</I>,&#160;<I>Cut Numbers</I>, and&#160;<I>Trinities</I>. His nonfiction works include&#160;<I>Where Dead Voices Gather</I>,&#160;<I>The Devil and Sonny Liston</I>,&#160;<I>Dino</I>,&#160;<I>Power on Earth</I>,&#160;<I>Hellfire</I>,&#160;<I>Country</I>, and&#160;<I>Unsung Heroes of Rock &#39;n&#39; Roll<I>.</I></I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d20a7004